import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStopSquareFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.45436 5.58405C6.25505 4.72553 7.39162 4.25 8.7207 4.25H15.2812C16.6126 4.25 17.7494 4.7253 18.5498 5.58432C19.3446 6.43738 19.752 7.60829 19.752 8.9082V15.0918C19.752 16.3917 19.3446 17.5626 18.5498 18.4156C17.7495 19.2747 16.6126 19.75 15.2812 19.75H8.7207C7.38832 19.75 6.25129 19.2748 5.4511 18.4155C4.65655 17.5623 4.25 16.3913 4.25 15.0918V8.9082C4.25 7.60758 4.65909 6.43676 5.45436 5.58405Z",
		fill: "currentColor"
	})
});
export default SvgStopSquareFill;
